import { px2rem } from '../utils/helpers/style.js';

var defaultLevelBottomMargins = [px2rem(24), px2rem(24), px2rem(24), px2rem(16), px2rem(16)];
var getWebLevelFontSizes = function getWebLevelFontSizes(theme, level) {
  return theme.levelFontSizes[level - 1];
};
var getWebLevelBottomMargins = function getWebLevelBottomMargins(theme, level) {
  return theme.levelBottomMargins[level - 1];
};

export { defaultLevelBottomMargins, getWebLevelBottomMargins, getWebLevelFontSizes };
